import { frontendURL } from 'dashboard/helper/URLHelper';

const StockIndex = () => import('./pages/StockIndex.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/stock'),
      name: 'stock_index',
      component: StockIndex,
      meta: {
        permissions: ['administrator'],
      },
    },
  ],
};
